import React from 'react';
import Icon from '../../../components/AppIcon';

const SummaryCards = () => {
  const summaryData = [
    {
      id: 1,
      title: "Outstanding Amount",
      value: "₹2,45,680",
      change: "+12.5%",
      changeType: "increase",
      icon: "IndianRupee",
      color: "text-error",
      bgColor: "bg-error/10",
      description: "Pending payments"
    },
    {
      id: 2,
      title: "Monthly Billing",
      value: "₹8,92,340",
      change: "+8.2%",
      changeType: "increase",
      icon: "Receipt",
      color: "text-primary",
      bgColor: "bg-primary/10",
      description: "Current month total"
    },
    {
      id: 3,
      title: "Collections",
      value: "₹6,46,660",
      change: "-3.1%",
      changeType: "decrease",
      icon: "Wallet",
      color: "text-success",
      bgColor: "bg-success/10",
      description: "Received this month"
    },
    {
      id: 4,
      title: "Overdue Invoices",
      value: "23",
      change: "+5",
      changeType: "increase",
      icon: "AlertTriangle",
      color: "text-warning",
      bgColor: "bg-warning/10",
      description: "Past due date"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {summaryData.map((item) => (
        <div key={item.id} className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-smooth">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 ${item.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={item.icon} size={24} className={item.color} />
            </div>
            <div className={`flex items-center space-x-1 text-sm ${
              item.changeType === 'increase' ? 'text-success' : 'text-error'
            }`}>
              <Icon 
                name={item.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
              />
              <span>{item.change}</span>
            </div>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-2xl font-bold text-foreground">{item.value}</h3>
            <p className="text-sm font-medium text-foreground">{item.title}</p>
            <p className="text-xs text-muted-foreground">{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;